import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationTypeOfUSGDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationTypeOfUSG/GetDetail?` + params, null);

export const GetRefOBGyExaminationTypeOfUSGList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationTypeOfUSG/GetList?` + params, null);

export const CreateRefOBGyExaminationTypeOfUSG  = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationTypeOfUSG/Create`, data);

export const UpdateRefOBGyExaminationTypeOfUSG  = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationTypeOfUSG/Update`, data);

export const DeleteRefOBGyExaminationTypeOfUSG  = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationTypeOfUSG/Delete`, data);